const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/
const ISO_DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d{1,9})?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/

function isRealCalendarDate(year, month, day) {
  const value = new Date(Date.UTC(year, month - 1, day))
  return value.getUTCFullYear() === year && value.getUTCMonth() === month - 1 && value.getUTCDate() === day
}

/** Convert trusted API/database date forms without applying a local timezone. */
export function normalizeDateOnly(value) {
  if (value === null || value === undefined || value === '') return null
  let match
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null
    const year = String(value.getUTCFullYear()).padStart(4, '0')
    const month = String(value.getUTCMonth() + 1).padStart(2, '0')
    const day = String(value.getUTCDate()).padStart(2, '0')
    match = [null, year, month, day]
  } else if (typeof value === 'string') {
    const input = value.trim()
    if (!input) return null
    match = input.match(DATE_ONLY) || input.match(ISO_DATE_TIME)
  }
  if (!match) return null
  const [, yearText, monthText, dayText] = match
  if (!isRealCalendarDate(Number(yearText), Number(monthText), Number(dayText))) return null
  return `${yearText}-${monthText}-${dayText}`
}
